import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Maintenance from './components/Maintenance';
import Settings from './components/Settings';
import PdfViewer from './components/PdfViewer';
import AdminDashboard from './components/admin/AdminDashboard';
import ProductDetails from './components/admin/ProductDetails';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import ShippingPolicy from './components/ShippingPolicy';
import CancellationPolicy from './components/CancellationPolicy';
import HowToUse from './components/HowToUse';
import SupportWidget from './components/SupportWidget';
import SupportAdmin from './components/SupportAdmin';
import CopyrightNotice from './components/CopyrightNotice';
import NotFound from './components/NotFound';

const SubscriptionExpired = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-900">
    <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-yellow-700 backdrop-blur-sm max-w-md w-full">
      <h2 className="text-2xl font-bold text-yellow-500 mb-4">Subscription Expired</h2>
      <p className="text-gray-300 mb-6">Your subscription has expired. Please contact the administrator to renew your subscription.</p>
      <button
        onClick={() => {
          localStorage.clear();
          window.location.href = '/';
        }}
        className="w-full bg-yellow-500 text-gray-900 px-4 py-2 rounded-md hover:bg-yellow-600 transition-colors duration-200"
      >
        Back to Login
      </button>
    </div>
  </div>
);

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const subscriptionExpired = localStorage.getItem('subscriptionExpired') === 'true';
  
  if (!token) {
    return <Navigate to="/" />;
  }
  
  if (subscriptionExpired) {
    return <SubscriptionExpired />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  return token && role === 'admin' ? children : <Navigate to="/dashboard" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/" element={<Login />} />
        <Route path="/pdf/:filename" element={<PdfViewer />} />
        <Route path="/register" element={<Register />} />
        <Route path="/expired" element={<SubscriptionExpired />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/shipping" element={<ShippingPolicy />} />
        <Route path="/cancellation" element={<CancellationPolicy />} />
        <Route path="/how-to-use" element={<HowToUse />} />
        <Route path="/copyright" element={<CopyrightNotice />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/products/:id"
          element={
            <AdminRoute>
              <ProductDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/support-admin"
          element={
            <PrivateRoute>
              <SupportAdmin />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Routes>
        <Route
          path="*"
          element={
            !['/login', '/register'].includes(window.location.pathname) && <SupportWidget />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
